import React from 'react';

export default function Security() {
  return (
    <section id="security" className="security-section">
      <div className="container">
        <div className="grid grid-2 gap-8" style={{ alignItems: 'center' }}>
          <div>
            <div className="section-eyebrow">SECURITY & SCALABILITY</div>
            <h2 className="section-title">
              Built for <span className="text-gradient">Long-Term Growth</span>
            </h2>
            <p style={{ fontSize: 16, lineHeight: 1.7, marginBottom: 24 }}>
              The platform is designed with security, transparency, and scalability
              to support future ecosystem growth.
            </p>
            <div className="why-grid" style={{ marginTop: 0 }}>
              <div className="why-item"><div className="check">🛡️</div><div>Non-custodial</div></div>
              <div className="why-item"><div className="check">🔍</div><div>On-chain transparent</div></div>
              <div className="why-item"><div className="check">⚙️</div><div>Upgradeable logic</div></div>
              <div className="why-item"><div className="check">🚀</div><div>Ready to scale</div></div>
            </div>
          </div>
          <div className="card" style={{ textAlign: 'center', padding: 40 }}>
            <div style={{
              width: 120, height: 120, borderRadius: '50%',
              background: 'radial-gradient(circle, var(--accent-bright) 0%, var(--accent) 60%, transparent 100%)',
              margin: '0 auto 24px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 48, color: 'var(--text-inverse)',
              animation: 'coreGlow 3s ease-in-out infinite',
            }}>
              🔐
            </div>
            <h3 style={{ marginBottom: 12 }}>Your Keys. Your Tokens.</h3>
            <p>
              Connect any Web3 wallet — Trust Wallet, MetaMask, or any BEP-20 compatible
              wallet. We never hold your funds.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
